export default __webpack_public_path__ + "static/media/static-stat-icon.4d3d09c0.svg";